/* ============================================================
   CAVIATRA COUTURE — Shopify JS
   ============================================================ */

(function () {
  'use strict';

  let lockedScrollY = 0;

  function lockPageScroll(lock) {
    const isLocked = document.body.classList.contains('cv-scroll-lock');

    if (lock) {
      if (isLocked) return;
      lockedScrollY = window.scrollY || window.pageYOffset || 0;
      document.documentElement.classList.add('cv-scroll-lock');
      document.body.classList.add('cv-scroll-lock');
      document.body.style.top = `-${lockedScrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.position = 'fixed';
      return;
    }

    if (!isLocked) return;
    document.documentElement.classList.remove('cv-scroll-lock');
    document.body.classList.remove('cv-scroll-lock');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, lockedScrollY);
  }

  function cartAjaxRoute(route, fallback) {
    const path = route || fallback;
    return path.endsWith('.js') ? path : path + '.js';
  }

  /* ── Header scroll glass effect ───────────────────────────── */
  function initHeader() {
    const header = document.querySelector('.cv-header');
    const headerWrapper = document.querySelector('.cv-header-wrapper');
    const announcement = document.querySelector('.cv-announcement-wrapper');
    if (!header || !headerWrapper) return;
    if (header.dataset.cvHeaderBound === 'true') {
      if (typeof header.__cvSyncPosition === 'function') header.__cvSyncPosition();
      return;
    }
    header.dataset.cvHeaderBound = 'true';

    const getAnnouncementHeight = () => announcement ? announcement.getBoundingClientRect().height : 0;

    const onScroll = () => {
      const currentScrollY = window.scrollY;
      const isScrolled = currentScrollY > 24;
      const announcementHeight = getAnnouncementHeight();

      header.classList.toggle('is-scrolled', isScrolled);
      headerWrapper.style.top = `${Math.max(0, announcementHeight - currentScrollY)}px`;
    };
    header.__cvSyncPosition = onScroll;

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  /* ── Mobile nav drawer ─────────────────────────────────────── */
  function initMobileNav() {
    const openBtn = document.querySelector('.cv-header__hamburger');
    const nav = document.querySelector('.cv-mobile-nav');
    const closeBtn = document.querySelector('.cv-mobile-nav__close');
    const backdrop = nav?.querySelector('[data-mobile-nav-close]');
    const cartBtn = nav?.querySelector('.cv-mobile-nav__cart-toggle');
    if (!openBtn || !nav) return;
    if (nav.dataset.cvBound === 'true') return;
    nav.dataset.cvBound = 'true';

    const openNav = () => {
      nav.classList.add('is-open');
      nav.setAttribute('aria-hidden', 'false');
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('cv-nav-open');
      lockPageScroll(true);
    };
    const closeNav = () => {
      nav.classList.remove('is-open');
      nav.setAttribute('aria-hidden', 'true');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('cv-nav-open');
      lockPageScroll(false);
    };
    openBtn.addEventListener('click', openNav);
    if (closeBtn) closeBtn.addEventListener('click', closeNav);
    if (backdrop) backdrop.addEventListener('click', closeNav);
    nav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', closeNav);
    });
    if (cartBtn) {
      cartBtn.addEventListener('click', () => {
        closeNav();
        window.CaviatraCartDrawer?.open();
      });
    }
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && nav.classList.contains('is-open')) closeNav();
    });
  }

  /* ── Cart drawer ───────────────────────────────────────────── */
  function initCartDrawer() {
    const drawer = document.querySelector('.cv-cart');
    const backdrop = document.querySelector('.cv-cart-backdrop');
    if (!drawer) return;
    if (drawer.dataset.cvBound === 'true') return;
    drawer.dataset.cvBound = 'true';
    let isOpen = false;

    function openCart() {
      if (isOpen) return;
      isOpen = true;
      drawer.classList.add('is-open');
      backdrop && backdrop.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cv-cart-open');
      lockPageScroll(true);
    }
    function closeCart() {
      if (!isOpen) return;
      isOpen = false;
      drawer.classList.remove('is-open');
      backdrop && backdrop.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cv-cart-open');
      lockPageScroll(false);
    }

    // Toggle buttons in header
    document.querySelectorAll('.cv-cart-toggle').forEach((btn) => {
      btn.addEventListener('click', openCart);
    });
    // Close button inside drawer
    document.querySelectorAll('.cv-cart__close').forEach((btn) => {
      btn.addEventListener('click', closeCart);
    });
    // Backdrop click
    backdrop && backdrop.addEventListener('click', closeCart);
    document.addEventListener('click', (event) => {
      if (!isOpen) return;
      const clickedToggle = event.target.closest('.cv-cart-toggle');
      if (clickedToggle) return;
      if (!drawer.contains(event.target) && !backdrop?.contains(event.target)) closeCart();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isOpen) closeCart();
    });

    // Expose for Shopify cart AJAX callbacks
    window.CaviatraCartDrawer = { open: openCart, close: closeCart };
    window.CaviatreCartDrawer = window.CaviatraCartDrawer;
  }

  /* ── Reveal on scroll ──────────────────────────────────────── */
  function initReveal() {
    const els = document.querySelectorAll('.cv-reveal');
    if (!els.length) return;
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add('is-in'); }),
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
  }

  /* ── Science charts ────────────────────────────────────────── */
  function initScienceCharts() {
    document.querySelectorAll('.cv-chart__fill[data-height]').forEach((fill) => {
      const height = parseInt(fill.dataset.height || '0', 10);
      fill.style.height = `${Math.max(0, height)}px`;
    });
  }

  function initProfileBars() {
    document.querySelectorAll('.cv-profile__fill[data-width]').forEach((fill) => {
      const width = parseInt(fill.dataset.width || '0', 10);
      fill.style.width = `${Math.max(0, Math.min(100, width))}%`;
    });
  }

  /* ── FAQ accordion ──────────────────────────────────────────── */
  function initFAQ() {
    document.querySelectorAll('.cv-faq__item').forEach((item) => {
      const btn = item.querySelector('.cv-faq__btn');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');
        // Close all
        document.querySelectorAll('.cv-faq__item.is-open').forEach((el) => el.classList.remove('is-open'));
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }

  /* ── PDP Accordion ──────────────────────────────────────────── */
  function initAccordion() {
    document.querySelectorAll('.cv-acc__item').forEach((item) => {
      const btn = item.querySelector('.cv-acc__btn');
      if (!btn) return;
      if (btn.dataset.cvBound === 'true') return;
      btn.dataset.cvBound = 'true';
      btn.addEventListener('click', () => item.classList.toggle('is-open'));
    });
  }

  /* ── PDP sticky ATC ─────────────────────────────────────────── */
  function initStickyATC() {
    const atc = document.querySelector('.cv-sticky-atc');
    const hero = document.querySelector('.cv-pdp__hero-ref');
    if (!atc || !hero) return;
    const onScroll = () => {
      const rect = hero.getBoundingClientRect();
      atc.classList.toggle('is-visible', rect.bottom < 100);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── PDP gallery thumbs ─────────────────────────────────────── */
  function initGallery() {
    const thumbs = document.querySelectorAll('.cv-pdp__thumb');
    const mainImgs = document.querySelectorAll('.cv-pdp__slide');
    if (!thumbs.length || !mainImgs.length) return;

    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => {
        thumbs.forEach((t) => t.classList.remove('is-active'));
        mainImgs.forEach((img) => img.classList.remove('is-active'));
        thumb.classList.add('is-active');
        if (mainImgs[i]) mainImgs[i].classList.add('is-active');
        const counter = document.querySelector('.cv-pdp__main-counter');
        if (counter) counter.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(thumbs.length).padStart(2, '0');
      });
    });
  }

  function initPdpQuantity() {
    const minus = document.getElementById('cv-qty-minus');
    const plus = document.getElementById('cv-qty-plus');
    const display = document.getElementById('cv-qty-display');
    const input = document.getElementById('cv-qty-input');
    if (!minus || !plus || !display || !input) return;
    if (minus.dataset.cvBound === 'true') return;
    minus.dataset.cvBound = 'true';
    plus.dataset.cvBound = 'true';

    const syncQty = (nextValue) => {
      const value = Math.max(1, nextValue);
      input.value = value;
      display.textContent = value;
    };

    minus.addEventListener('click', () => syncQty(parseInt(input.value || '1', 10) - 1));
    plus.addEventListener('click', () => syncQty(parseInt(input.value || '1', 10) + 1));
  }

  /* ── PDP variant picker ─────────────────────────────────────── */
  function initVariantPicker() {
    const variants = document.querySelectorAll('.cv-variant');
    if (!variants.length) return;

    variants.forEach((btn) => {
      if (btn.dataset.cvBound === 'true') return;
      btn.dataset.cvBound = 'true';
      btn.addEventListener('click', () => {
        variants.forEach((v) => {
          v.classList.remove('is-active');
          v.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        // Update price displays
        const price = btn.dataset.price;
        const variantId = btn.dataset.variantId;
        if (price) {
          document.querySelectorAll('.cv-pdp__price-val').forEach((el) => (el.textContent = price));
          document.querySelectorAll('.cv-sticky-atc__price-val').forEach((el) => (el.textContent = price));
        }
        // Update Shopify variant ID on the form
        const variantInput = document.querySelector('input[name="id"]');
        if (variantInput && variantId) variantInput.value = variantId;
        // Update sticky label
        const label = btn.dataset.label;
        const sub = btn.dataset.sub;
        if (label) {
          const stickyVariant = document.querySelector('.cv-sticky-atc__variant');
          if (stickyVariant) stickyVariant.textContent = label + (sub ? ' · ' + sub : '');
        }
        const stickyName = document.querySelector('.cv-sticky-atc__name');
        const productTitle = document.querySelector('.cv-pdp__title');
        if (stickyName && productTitle) stickyName.textContent = productTitle.textContent.trim();
      });
    });
  }

  /* ── Mega menu hover ────────────────────────────────────────── */
  function initMegaMenu() {
    const navItems = document.querySelectorAll('.cv-header__nav [data-mega]');
    navItems.forEach((item) => {
      const megaId = item.dataset.mega;
      const mega = document.getElementById(megaId);
      if (!mega) return;
      item.addEventListener('mouseenter', () => mega.removeAttribute('hidden'));
      item.addEventListener('mouseleave', () => mega.setAttribute('hidden', ''));
      mega.addEventListener('mouseenter', () => mega.removeAttribute('hidden'));
      mega.addEventListener('mouseleave', () => mega.setAttribute('hidden', ''));
    });
  }

  /* ── Cart refresh via Shopify Sections API ─────────────────── */
  async function refreshCartUI() {
    const [sectionsRes, cartRes] = await Promise.all([
      fetch('/?sections=cv-header,cv-cart-drawer'),
      fetch(cartAjaxRoute(window.routes?.cart_url, '/cart')),
    ]);
    const cart = await cartRes.json();

    if (sectionsRes.ok) {
      const sections = await sectionsRes.json();
      const html = sections['cv-header'] || sections['cv-cart-drawer'];
      if (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        // Items list (re-renders qty, remove, cross-sell)
        const curItems = document.querySelector('#cv-cart-items');
        const newItems = doc.querySelector('#cv-cart-items');
        if (curItems && newItems) curItems.innerHTML = newItems.innerHTML;
        // Item count in header
        const curCount = document.querySelector('#cv-cart-item-count');
        const newCount = doc.querySelector('#cv-cart-item-count');
        if (curCount && newCount) curCount.textContent = newCount.textContent;
        // Subtotal
        const curSub = document.querySelector('#cv-cart-subtotal');
        const newSub = doc.querySelector('#cv-cart-subtotal');
        if (curSub && newSub) curSub.textContent = newSub.textContent;
        const curCheckoutPrice = document.querySelector('#cv-cart-checkout-price');
        const newCheckoutPrice = doc.querySelector('#cv-cart-checkout-price');
        if (curCheckoutPrice && newCheckoutPrice) curCheckoutPrice.textContent = newCheckoutPrice.textContent;
        // Progress bar + text
        const curFill = document.querySelector('.cv-cart__progress-fill');
        const newFill = doc.querySelector('.cv-cart__progress-fill');
        if (curFill && newFill) {
          curFill.dataset.progress = newFill.dataset.progress || '0';
          curFill.style.setProperty('--cv-progress', `${Math.max(0, Math.min(parseInt(curFill.dataset.progress || '0', 10), 100)) / 100}`);
        }
        const curPrgTxt = document.querySelector('.cv-cart__progress-text span:first-child');
        const newPrgTxt = doc.querySelector('.cv-cart__progress-text span:first-child');
        if (curPrgTxt && newPrgTxt) curPrgTxt.textContent = newPrgTxt.textContent;
        const curPct = document.querySelector('.cv-cart__progress-pct');
        const newPct = doc.querySelector('.cv-cart__progress-pct');
        if (curPct && newPct) curPct.textContent = newPct.textContent;
        const curPayments = document.querySelector('.cv-cart__payments');
        const newPayments = doc.querySelector('.cv-cart__payments');
        if (curPayments && newPayments) curPayments.innerHTML = newPayments.innerHTML;
      }
    }

    // Always update header bubble from JSON (guaranteed correct)
    const bubble = document.querySelector('.cv-cart-bubble');
    if (bubble) bubble.textContent = cart.item_count;
    const mobileCartCount = document.querySelector('.cv-mobile-nav__cart-toggle span');
    if (mobileCartCount) mobileCartCount.textContent = cart.item_count;
    return cart;
  }

  function initCartProgress() {
    document.querySelectorAll('.cv-cart__progress-fill').forEach((fill) => {
      const progress = parseInt(fill.dataset.progress || '0', 10);
      fill.style.setProperty('--cv-progress', `${Math.max(0, Math.min(progress, 100)) / 100}`);
    });
  }

  /* ── Cart qty + remove via event delegation ─────────────────── */
  function initCartInteractions() {
    const cartEl = document.querySelector('.cv-cart');
    if (!cartEl) return;

    cartEl.addEventListener('click', async (e) => {
      // Qty +/-
      const qtyBtn = e.target.closest('.cv-cart__qty-minus, .cv-cart__qty-plus');
      if (qtyBtn) {
        const line = parseInt(qtyBtn.dataset.line);
        const isPlus = qtyBtn.classList.contains('cv-cart__qty-plus');
        const qtyEl = qtyBtn.closest('.cv-cart__qty')?.querySelector('.cv-cart__qty-val');
        const newQty = Math.max(0, parseInt(qtyEl?.textContent || '1') + (isPlus ? 1 : -1));
        qtyBtn.disabled = true;
        try {
          await fetch(cartAjaxRoute(window.routes?.cart_change_url, '/cart/change'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line, quantity: newQty }),
          });
          await refreshCartUI();
        } catch (err) {
          console.error('Cart qty change failed', err);
        } finally {
          qtyBtn.disabled = false;
        }
        return;
      }

      // Remove
      const removeBtn = e.target.closest('.cv-cart__item-remove');
      if (removeBtn) {
        const line = parseInt(removeBtn.dataset.line);
        removeBtn.textContent = '…';
        try {
          await fetch(cartAjaxRoute(window.routes?.cart_change_url, '/cart/change'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line, quantity: 0 }),
          });
          await refreshCartUI();
        } catch (err) {
          console.error('Cart remove failed', err);
        }
        return;
      }

      const crosssellAddBtn = e.target.closest('.cv-cart__crosssell-add[data-variant-id]');
      if (crosssellAddBtn) {
        const variantId = parseInt(crosssellAddBtn.dataset.variantId, 10);
        if (!variantId) return;
        crosssellAddBtn.disabled = true;
        try {
          const res = await fetch(cartAjaxRoute(window.routes?.cart_add_url, '/cart/add'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          });
          if (!res.ok) throw new Error();
          await refreshCartUI();
        } catch (err) {
          console.error('Cart cross-sell add failed', err);
        } finally {
          crosssellAddBtn.disabled = false;
        }
      }
    });
  }

  /* ── Hero "In den Warenkorb" button ────────────────────────── */
  function initHeroATC() {
    document.querySelectorAll('.cv-hero__atc').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const variantId = btn.dataset.variantId;
        if (!variantId) return;
        const orig = btn.innerHTML;
        btn.disabled = true;
        btn.textContent = '…';
        try {
          const res = await fetch(cartAjaxRoute(window.routes?.cart_add_url, '/cart/add'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId), quantity: 1 }),
          });
          if (!res.ok) throw new Error();
          // Open drawer immediately — refresh content in background
          window.CaviatraCartDrawer?.open();
          refreshCartUI();
        } catch (err) {
          console.error('Hero ATC failed', err);
        } finally {
          btn.disabled = false;
          btn.innerHTML = orig;
        }
      });
    });
  }

  /* ── Add to cart AJAX ───────────────────────────────────────── */
  function initAddToCart() {
    document.querySelectorAll('.cv-atc-form').forEach((form) => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = form.querySelector('[type="submit"]');
        const variantId = form.querySelector('input[name="id"]')?.value;
        const qty = parseInt(form.querySelector('input[name="quantity"]')?.value || '1');
        if (!variantId) return;
        const origHTML = btn?.innerHTML;
        if (btn) { btn.disabled = true; btn.textContent = '…'; }
        try {
          const res = await fetch(cartAjaxRoute(window.routes?.cart_add_url, '/cart/add'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId), quantity: qty }),
          });
          if (!res.ok) throw new Error();
          // Open immediately — don't wait for refresh
          window.CaviatraCartDrawer?.open();
          refreshCartUI();
        } catch (err) {
          console.error('Add to cart failed', err);
        } finally {
          if (btn) { btn.disabled = false; btn.innerHTML = origHTML; }
        }
      });
    });

    document.querySelectorAll('.cv-xsell-card__add[data-variant-id]').forEach((button) => {
      if (button.dataset.cvBound === 'true') return;
      button.dataset.cvBound = 'true';
      button.addEventListener('click', async () => {
        const variantId = parseInt(button.dataset.variantId, 10);
        if (!variantId) return;
        const original = button.innerHTML;
        button.disabled = true;
        button.textContent = '…';
        try {
          const res = await fetch(cartAjaxRoute(window.routes?.cart_add_url, '/cart/add'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          });
          if (!res.ok) throw new Error();
          window.CaviatraCartDrawer?.open();
          refreshCartUI();
        } catch (err) {
          console.error('PDP cross-sell add failed', err);
        } finally {
          button.disabled = false;
          button.innerHTML = original;
        }
      });
    });
  }

  /* ── Boot ───────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', () => {
    initHeader();
    initMobileNav();
    initCartDrawer();
    initReveal();
    initCartProgress();
    initScienceCharts();
    initProfileBars();
    initFAQ();
    initAccordion();
    initStickyATC();
    initGallery();
    initPdpQuantity();
    initVariantPicker();
    initMegaMenu();
    initCartInteractions();
    initHeroATC();
    initAddToCart();
  });

  // Re-run reveal after Shopify section events (Theme Editor)
  document.addEventListener('shopify:section:load', () => {
    initReveal();
    initCartProgress();
    initScienceCharts();
    initProfileBars();
    initFAQ();
    initAccordion();
    initHeader();
    initMobileNav();
    initCartDrawer();
    initCartInteractions();
    initMegaMenu();
    initPdpQuantity();
  });
})();
